const initialState = {
  loading: false
};

const community = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_STATS_FOR_SCHOOL_MAIN_REQUEST':
    case 'GET_STATS_FOR_SCHOOL_MAIN_SUCCESS':
    case 'GET_STATS_FOR_SCHOOL_MAIN_FAILED':
    case 'GET_RECENT_CAUSES_FOR_COMMUNITY_MAIN_FAILED':
    case 'GET_RECENT_CAUSES_FOR_COMMUNITY_MAIN_SUCCESS':
    case 'GET_RECENT_CAUSES_FOR_COMMUNITY_MAIN_REQUEST':
    case 'GET_FEATURED_COMMUNITY_FOR_COMMUNITY_MAIN_REQUEST':
    case 'GET_FEATURED_COMMUNITY_FOR_COMMUNITY_MAIN_FAILED':
    case 'GET_FEATURED_COMMUNITY_FOR_COMMUNITY_MAIN_SUCCESS': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default community;
